import React, { Component, Fragment } from 'react'
import algoliasearch from 'algoliasearch'
import { inject, observer } from 'mobx-react'
import Content from '../content/components/content'
import Loader from '../components/loader'
import Detail from './Detail'
import User from '../models/UserStore'
import './Home.css'
import axios from 'axios'


class Home extends Component {
  state = {
    userId: User.getUid(),
    bodyTop: 0,
    isOpen: false,
    seenapses: [],
    user: {
      has_subscription: '',
      days: '',
    },
    code: 'MX'
  }

  componentDidUpdate(_, prevState) {
    if (prevState.seenapses !== this.state.seenapses) {
      this.props.modalStore.onFooter(true)
    }
  }

  componentDidMount() {
    let date = new Date()
    let currentDay = date.getDay()
    this.props.modalStore.removeBlur()
    this.props.modalStore.onFooter(false)

    axios.get(`https://api.ipregistry.co/?hostname=true&key=42hkqliczzu2r0bf`).then(({data}) => {
      this.setState({country: data.location.country.code})
    })
    
    User.getUserProfile(this.state.userId)
      .then(res => {
      this.setState({
        user: res.data
      })
    })
    .catch(error => console.log('error en el fetch', error))
  }

  componentWillReceiveProps(nextProps, nextState) {
    if (!!nextProps.match.params.parent && !!nextProps.match.params.child) {
      this.props.modalStore.addBlurOnHeader()
      this.setState({
        bodyTop: document.querySelector('body').getBoundingClientRect().y,
        isOpen: true
      })
    } else {
      this.props.modalStore.removeBlur()
      this.setState({ isOpen: false })
    }
  }

  handleScroll = (e) => {
    console.log(e);
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    const isBottom = scrollTop + clientHeight >= scrollHeight;
    if (isBottom) {
      
    }
  };
  

  render() {
    const {
      match,
      modalStore: { blur },
      inspiredStore: {lang}
    } = this.props

    if (this.state.isOpen) {
      document.querySelector('body').classList.add('locked')
      document.querySelector('body').style.top = `${this.state.bodyTop}px`
    } else {
      document.querySelector('body').classList.remove('locked')
      document.querySelector('body').style.top = ``
      if (this.state.bodyTop) {
        window.scroll(0, -this.state.bodyTop)
        this.setState({
          bodyTop: 0
        })
      }
    }    
  
    return (
      <Fragment>
        <div
          onScroll={this.handleScroll}
          className='container-fluid contenedor top-sm'
          style={{ filter: `blur(${blur})` }}
        >
          
        <Content dataSeenapse={this.state.seenapses} user={this.state.user} lang={lang} country={this.state.country}/>
         
        </div>
        {this.state.isOpen && (
          <Detail
            open={this.state.isOpen}
            parent={match.params.parent}
            child={match.params.child}
          />
        )}
      </Fragment>
    )
  }
}

export default inject('modalStore', 'inspiredStore')(observer(Home))



// WEBPACK FOOTER //
// ./src/containers/Home.jsx